module.exports = __webpack_public_path__ + "img/img_banner_01@1x.6ad191eb.jpg";